'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChariot = void 0;
var react_1 = require("react");
var ChariotContext_1 = require("../ChariotContext");
var useChariot = function () {
    var chariot = (0, react_1.useContext)(ChariotContext_1.ChariotContext);
    return chariot;
};
exports.useChariot = useChariot;
